import {
  ecommerceItems,
  pushDataLayerEvent,
  trackEcommerce,
  trackQuoteStarted,
  trackQuoteSubmitted,
  transactionEcommerce,
} from "./data-layer"
import { isQuoteRequest } from "../lib/purchase-tracking"

export const analyticsSelect = (item) => trackEcommerce("select_item", [item])
export const analyticsAddToCart = (item, quantity = 1) =>
  trackEcommerce("add_to_cart", [{ ...item, quantity }])
export const analyticsRemoveFromCart = (item, quantity = item?.quantity || 1) =>
  trackEcommerce("remove_from_cart", [{ ...item, quantity }])
export const analyticsUpdateCart = (item, quantity = 1) =>
  trackEcommerce("update_cart", [{ ...item, quantity }])
export const analyticsAddToWishlist = (productId) =>
  trackEcommerce("add_to_wishlist", [{ productId }])
export const analyticsRemoveFromWishlist = (productId) =>
  trackEcommerce("remove_from_wishlist", [{ productId }])
export const analyticsViewCart = (items) => trackEcommerce("view_cart", items)
export const analyticsBeginCheckout = (items) =>
  trackEcommerce("begin_checkout", items)
export const analyticsCheckoutDelivery = (items, shippingTier) =>
  trackEcommerce("add_shipping_info", items, {
    ecommerce: { shipping_tier: shippingTier },
  })
export const analyticsCheckoutViewPaymentOptions = (items, paymentType) =>
  trackEcommerce("add_payment_info", items, {
    ecommerce: { payment_type: paymentType },
  })
export const analyticsAddShippingInfo = analyticsCheckoutDelivery
export const analyticsAddPaymentInfo = analyticsCheckoutViewPaymentOptions
export const analyticsSelectPaymentMethod = (paymentType) =>
  pushDataLayerEvent("select_payment_method", { payment_type: paymentType })
export const analyticsPayNowOnOldOrder = (orderNumber) =>
  pushDataLayerEvent("repay_order", {
    order_number: String(orderNumber || ""),
  })
export const analyticsPlaceOrder = (items) => trackEcommerce("place_order", items)
export const analyticsQuoteStarted = trackQuoteStarted
export const analyticsQuoteSubmitted = trackQuoteSubmitted

export const analyticsPurchase = (order) => {
  if (isQuoteRequest(order)) return
  pushDataLayerEvent("purchase", { ecommerce: transactionEcommerce(order) })
}

export const analyticsRegister = () => pushDataLayerEvent("sign_up")
export const analyticsLogin = () => pushDataLayerEvent("login")
export const analyticsLogout = () => pushDataLayerEvent("logout")
export const analyticsUpdateAccount = () => pushDataLayerEvent("update_account")
export const analyticsViewItemList = (items = [], listId = "shop") =>
  trackEcommerce("view_item_list", items, {
    ecommerce: {
      item_list_id: listId,
      item_list_name: String(listId).replace(/_/g, " "),
    },
  })
export const analyticsViewItem = (item) => trackEcommerce("view_item", [item])

export { ecommerceItems }
